/**
 * Formatiert Dezimalstunden zu "Xh Ymin" Format
 * 
 * @param {number} decimalHours - Dezimalstunden (z.B. 34.35 = 34h 21min)
 * @param {boolean} showSign - Wenn true, wird bei positivem Wert ein "+" vorangestellt
 * @returns {string} Formatierte Zeit z.B. "+34h 21min" oder "-2h 30min"
 */
export function formatHoursToHM(decimalHours, showSign = false) {
  if (decimalHours === null || decimalHours === undefined || isNaN(decimalHours)) {
    return '0h 0min';
  }
  
  const isNegative = decimalHours < 0;
  const absHours = Math.abs(decimalHours);
  
  const hours = Math.floor(absHours);
  const minutes = Math.round((absHours - hours) * 60);
  
  // Handle edge case where rounding gives 60 minutes
  let finalHours = hours;
  let finalMinutes = minutes;
  if (minutes === 60) {
    finalHours = hours + 1;
    finalMinutes = 0;
  }
  
  const sign = isNegative ? '-' : (showSign ? '+' : '');
  return `${sign}${finalHours}h ${finalMinutes}min`;
}

/**
 * Formatiert Minuten zu "Xh Ymin" Format
 * 
 * @param {number} minutes - Minuten
 * @returns {string} Formatierte Zeit z.B. "2h 30min"
 */
export function formatMinutesToHM(minutes) {
  if (!minutes || minutes < 0) return '0h 0min';
  const hours = Math.floor(minutes / 60);
  const mins = Math.round(minutes % 60);
  return `${hours}h ${mins}min`;
}
